export const scrollToFeatures = () => {
  const element = document.getElementById('feature_container');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

export const scrollToScheduleDemo = () => {
  const element = document.getElementById('schedule_demo_container');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};
